var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _c("client-board-sort", {
        staticClass: "text-right mr-4",
        attrs: {
          "sort-by": _vm.sortBy,
          "no-activity-first": _vm.noActivityFirst,
          "sort-by-order": _vm.sortByOrder,
        },
        on: { change: _vm.handleSortChange },
      }),
      _vm._v(" "),
      _c("client-board-filter", {
        staticClass: "text-right mr-4",
        attrs: { referrers: _vm.referrersValues, agents: _vm.agentsValues },
        on: { reset: _vm.handleResetFilter },
        model: {
          value: _vm.clientBoardFilter,
          callback: function ($$v) {
            _vm.clientBoardFilter = $$v
          },
          expression: "clientBoardFilter",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }